const appconfig = {
    "dateformatter": "MM/dd/yyyy"
}

export default appconfig;